export const CountryOfIncorporationValues = {
  US: "United States",
  CA: "Canada",
  GB: "United Kingdom",
  AU: "Australia",
  IE: "Ireland",
  ES: "Spain",
  NL: "Netherlands",
  BE: "Belgium",
  DK: "Denmark",
  DE: "Germany",
  SE: "Sweden",
  OTHER: "Other",
} as const;

export type CurrencyCode =
  | "USD"
  | "CAD"
  | "GBP"
  | "AUD"
  | "EUR"
  | "DKK"
  | "SEK";
